module.exports = __webpack_public_path__ + "494cd07c/img/comments-icon.fdec7fdb.svg";